module.exports = __webpack_public_path__ + "static/media/findInternsMain.08adf212.png";